import { NarrativeTemplate } from './templates'

export const anomalyTemplates: NarrativeTemplate[] = [
  // Critical severity with historical matches
  {
    id: 'anomaly-critical-historical',
    category: 'anomaly',
    condition: (data) => data.severityLevel === 'CRITICAL' && Boolean(data.hasHistoricalMatches),
    priority: 100,
    template: `CRITICAL ANOMALY DETECTED on {assetId}

Pattern: {category}
Severity: {severityLevel}
Confidence: {confidenceFormatted}

Affected Sensors:
{sensorsFormatted}

Historical Context:
This pattern matches {matchCount} previous incident(s) in the system. Based on historical data, similar patterns have led to component failure within 24-72 hours.

{recommendation}

Action Required: Immediate inspection recommended.`
  },

  // Critical severity without history
  {
    id: 'anomaly-critical',
    category: 'anomaly',
    condition: (data) => data.severityLevel === 'CRITICAL',
    priority: 90,
    template: `CRITICAL ANOMALY DETECTED on {assetId}

Pattern: {category}
Severity: {severityLevel}
Confidence: {confidenceFormatted}

Affected Sensors:
{sensorsFormatted}

This is a new pattern without historical precedent in the system. The high confidence score indicates genuine anomalous behavior requiring investigation.

{recommendation}

Action Required: Prioritize inspection to determine root cause.`
  },

  // High severity
  {
    id: 'anomaly-high',
    category: 'anomaly',
    condition: (data) => data.severityLevel === 'HIGH',
    priority: 80,
    template: `HIGH PRIORITY ANOMALY on {assetId}

Pattern: {category}
Severity: {severityLevel}
Confidence: {confidenceFormatted}

Sensors Involved:
{sensorsFormatted}

Analysis:
The detected pattern indicates potential degradation that should be addressed within 24-48 hours to prevent escalation.

{recommendation}`
  },

  // Medium severity
  {
    id: 'anomaly-medium',
    category: 'anomaly',
    condition: (data) => data.severityLevel === 'MEDIUM',
    priority: 60,
    template: `Anomaly Alert for {assetId}

Pattern: {category}
Priority: {severityLevel}
Confidence: {confidenceFormatted}

Affected Components:
{sensorsFormatted}

This anomaly warrants monitoring but does not require immediate action. Schedule inspection during the next maintenance window.

{recommendation}`
  },

  // Low severity
  {
    id: 'anomaly-low',
    category: 'anomaly',
    condition: (data) => data.severityLevel === 'LOW',
    priority: 40,
    template: `Minor Anomaly on {assetId}

Pattern: {category}
Priority: {severityLevel}

Sensors: {sensorsFormatted}

This is a low-priority observation. Continue monitoring for any escalation in severity. No immediate action required.`
  },

  // Sensor drift specific
  {
    id: 'anomaly-sensor-drift',
    category: 'anomaly',
    condition: (data) => String(data.category).toLowerCase().includes('drift'),
    priority: 75,
    template: `Sensor Drift Detected on {assetId}

Type: {category}
Severity: {severityLevel}
Confidence: {confidenceFormatted}

Drifting Sensors:
{sensorsFormatted}

Sensor drift can indicate:
• Calibration issues requiring recalibration
• Gradual component wear
• Environmental factors affecting readings

{recommendation}`
  },

  // Default
  {
    id: 'anomaly-default',
    category: 'anomaly',
    priority: 10,
    template: `Anomaly detected on {assetId}: {category}

Severity: {severityLevel}
Confidence: {confidenceFormatted}
Sensors: {sensorsFormatted}

{recommendation}`
  }
]
